import { ActivatedRouteSnapshot, CanActivateFn, ResolveFn, Route, Router } from '@angular/router';
import { inject } from '@angular/core';
import { LeistungService } from './leistung.service';
import {
  ILeistungAbrechnungParams,
  MgsRole,
  ROLE_MGS_ARZT,
  ROLE_MGS_BUCHUNG,
  ROLE_MGS_KIDS,
  ROLE_MGS_SPOWI,
  ROLE_MGS_USER_FOR_KIDS_TERMIN
} from '@mng/mgs-lib';
import { createIconResolver } from '@mng/mng-icon';
import { MGS_CHECKED_ICON, MGS_WARNING_ICON } from '../../mgs-svg-icon.helper';
import { mgsExclusionRoleGuard } from '../../mgs-guards';
import { LEISTUNG_ABRECHNUNGEN_PATH, LEISTUNG_PATH, LEISTUNG_TITLE } from '../../mgs-path-defs';
import { PartnerAuswahlService } from '../../partner/partner-auswahl/partner-auswahl.service';
import { AuthStateFacade } from '../../auth/auth-state.facade';
import { partnerResolver } from '../../partner/partner.resolver';
import { dienstleistungArtenResolver } from '../../dienstleistung/dienstleistung-arten.resolver';

const queryParamAbrechnungId = 'abrechnungId';

const leistungenResolver: ResolveFn<void> = async (route: ActivatedRouteSnapshot) => {
  const authState = inject(AuthStateFacade);
  const leistungService = inject(LeistungService);
  const partnerService = inject(PartnerAuswahlService);

  const params: ILeistungAbrechnungParams = { ...leistungService.params() };

  if (route.queryParams[queryParamAbrechnungId]) {
    return leistungService.ermittleLeistungenFuerAbrechnung(
      route.queryParams[queryParamAbrechnungId],
      route.queryParams['code']
    );
  }

  if (route.queryParams['stichtag']) {
    params.stichtag = route.queryParams['stichtag'];
  }

  if (authState.isAdmin()) {
    const partnerId = partnerService.partnerIdErmitteln(route);
    if (partnerId) {
      params.partnerId = partnerId;
      return leistungService.ermittleLeistungen(params);
    }
  } else {
    return leistungService.ermittleLeistungen(params);
  }
};

export const leistungRolesForExclusion: MgsRole[] = [
  ROLE_MGS_KIDS,
  ROLE_MGS_USER_FOR_KIDS_TERMIN,
  ROLE_MGS_BUCHUNG,
  ROLE_MGS_ARZT,
  ROLE_MGS_SPOWI
];

export const leistungGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authStateFacade = inject(AuthStateFacade);
  const router = inject(Router);

  // Prüfung dass ein "Abrechnung" User nur die Leistung für die Anzeige einer Abrechnung aufrufen kann
  // (der Indikator dafür ist das Vorhandensein eines queryParams
  if (authStateFacade.isAbrechnungUser() && !route.queryParams[queryParamAbrechnungId]) {
    // zu Abrechnungen verzweigen
    return router.createUrlTree(['/', LEISTUNG_ABRECHNUNGEN_PATH]);
  }

  return true;
};

export const leistungRoute: Route = {
  path: LEISTUNG_PATH,
  title: LEISTUNG_TITLE,
  loadComponent: () => import('./leistung.component'),
  resolve: {
    partner: partnerResolver,
    leistungen: leistungenResolver,
    dienstleistungArten: dienstleistungArtenResolver,
    icons: createIconResolver(MGS_WARNING_ICON, MGS_CHECKED_ICON)
  },
  canActivate: [mgsExclusionRoleGuard(leistungRolesForExclusion), leistungGuard]
};
